import { render, staticRenderFns } from "./UnverifiedUserDialog.vue?vue&type=template&id=390bf480&"
import script from "./UnverifiedUserDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./UnverifiedUserDialog.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports